import css from '@styled-system/css';
import styled from 'styled-components';
import theme from '../theme';
import { grid, compose, color, layout, space } from 'styled-system';
const Grid = styled.div `
  ${css({
    display: 'grid'
})}
  ${compose(color, layout, grid, space)}
`;
Grid.defaultProps = { theme };
export default Grid;
//# sourceMappingURL=Grid.js.map